// Stores the browser-resolved image URL (from <picture> currentSrc) for seamless view transitions.
// Set by ProductCard on click, read by detail page for the initial image.
export const transitionImages: Record<string, string> = {};

// True while a view transition is in progress (SPA navigation).
// Page components use this to skip entry animations that would conflict.
export let isViewTransitioning = false;
export function setViewTransitioning(value: boolean) {
	isViewTransitioning = value;
}
